import { Loader2 } from 'lucide-react';

interface PageLoaderProps {
  label?: string;
  className?: string;
}

export default function PageLoader({
  label = 'Загрузка...',
  className = 'min-h-[60vh]',
}: PageLoaderProps) {
  return (
    <div
      className={`flex flex-1 items-center justify-center ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{label}</p>
      </div>
    </div>
  );
}
